export const BOOKING_DETAIL_TABS = [
  { id: 'overview', label: 'Überblick' },
  { id: 'guest', label: 'Gast' },
  { id: 'billing', label: 'Geld' },
  { id: 'history', label: 'Verlauf' },
] as const;

export type BookingDetailTab = (typeof BOOKING_DETAIL_TABS)[number]['id'];

const TAB_IDS = new Set<BookingDetailTab>(BOOKING_DETAIL_TABS.map((tab) => tab.id));

/** Frühere Reiter, die in einem anderen aufgegangen sind; geteilte Links landen dort. */
const MOVED: Record<string, BookingDetailTab> = { documents: 'guest' };

export function bookingDetailTabFromSearch(value: unknown): BookingDetailTab {
  if (typeof value !== 'string') return 'overview';
  if (TAB_IDS.has(value as BookingDetailTab)) return value as BookingDetailTab;
  return MOVED[value] ?? 'overview';
}
